exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".options-container[data-v-7c6177af]{display:grid;gap:10px;grid-template-columns:repeat(auto-fill, minmax(120px, 1fr));align-items:start}\n", ""]);

